import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, NavParams, PopoverController } from '@ionic/angular';

import { isUrl as isURL } from 'src/app/utils/utils';
import { ColonToEmojiPipe } from 'src/pipes/colonToEmoji.pipe';

export interface ActionDropdownType {
  label: string;
  icon?: string;
  emoji?: string;
  selected?: boolean;
  metadata?: any;
  id?: string;
  destructive?: boolean;
  description?: string;
  subOptions?: ActionDropdownType[];
}

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ScrollingModule, ColonToEmojiPipe],
  selector: 'app-action-dropdown',
  templateUrl: './action-dropdown.component.html',
  styleUrls: ['./action-dropdown.component.scss'],
})
export class ActionDropdownComponent {
  options: ActionDropdownType[] = [];
  itemClass?: string;
  checkbox: boolean;
  multiCheckbox: boolean;
  callback: (index: number, label: string, id?: string, metadata?: any) => {};
  onCloseCallback: () => {};
  parentPopover?: any;

  public isURL = isURL;

  constructor(
    navParmas: NavParams,
    private popoverCtrl: PopoverController,
  ) {
    this.options = navParmas.get('options');
    this.checkbox = navParmas.get('checkbox');
    this.parentPopover = navParmas.get('parentPopover');

    if (this.checkbox) {
      this.options.map((opt) => {
        opt.icon = opt.selected ? 'checkbox' : 'square-outline';
      });
    }
  }

  async didClick(event: any, index: number, label: string, id?: string, metadata?: any) {
    const option = this.options[index];

    // If the option has sub-options, don't call the callback - let the nested popover handle it
    if (option.subOptions && option.subOptions.length > 0) {
      return;
    }

    if (this.checkbox) {
      option.selected = !option.selected;
      option.icon = option.selected ? 'checkbox' : 'square-outline';

      this.options.splice(index, 1, option);
    }

    this.callback(index, label, id, metadata);
  }

  didClickSubOption(parentIndex: number, subIndex: number, subLabel: string, subId?: string, subMetadata?: any) {
    const parentOption = this.options[parentIndex];

    // Call the parent callback with both parent and sub-option information
    this.callback(parentIndex, parentOption.label, parentOption.id, {
      ...parentOption.metadata,
      subOption: {
        index: subIndex,
        label: subLabel,
        id: subId,
        metadata: subMetadata,
      },
    });
  }

  async showSubOptions(parentOption: ActionDropdownType, parentIndex: number, clickEvent?: any) {
    // This method is no longer needed with the new approach
    // The nested popover is handled directly in the template
  }

  onClose() {
    this.onCloseCallback();
  }
}
